import { Input } from "antd";

export const getSearchableHeader = (
  title: string,
  dataIndex: string,
  setColumnSearch: React.Dispatch<React.SetStateAction<Record<string, string>>>,
) => (
  <div
    onClick={(e) => e.stopPropagation()}
    style={{ display: "flex", flexDirection: "column" }}
  >
    <span style={{ fontWeight: 600 }}>{title}</span>
    <Input
      size="small"
      placeholder={`Search ${title}`}
      onClick={(e) => e.stopPropagation()}
      allowClear
      onChange={(e) =>
        setColumnSearch((prev) => ({
          ...prev,
          [dataIndex]: e.target.value,
        }))
      }
      style={{ marginTop: 4, width: "100%" }}
    />
  </div>
);
